import React, { Component } from 'react';
import { Container, Nav, Alert } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { GoRepo, GoGear } from "react-icons/go";
import Profile from "components/org/profile";
import Blobs from "components/org/blobs";
import Settings from "./settings/settings";
import { isNavKeyboardSelect } from "context/keyboard";
import ReactGA from 'react-ga';
import Title from 'context/title';
import Utils from 'context/utils';

export default class Page extends Component {
  constructor(props) {
    super(props);

    this.state = {
      org: null,
      blobs: null,
      notFound: false
    };

    this.profileInterface = {
      loadProfile: this.loadProfile
    };

    // Guards title writes from late-arriving promise callbacks (see componentWillUnmount).
    this.unmounted = false;
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  componentDidMount() {
    // The alias is in the route params, so the tab is right from first paint; loadProfile upgrades
    // it to the org's name once that resolves.
    Title.set(this.props.match.params.orgId);

    ReactGA.pageview('/org');

    this.loadData();
  }

  loadData() {
    // Query organization profile
    this.loadProfile();

    // Query the list of blobs
    const orgId = this.props.match.params.orgId;
    this.props.app.api.orgsIdBlobsGet(orgId)
      .then(response => {
        // Remember data
        this.setState({ blobs: response.data.blobs });
      }, error => {});
  }

  loadProfile = () => {
    const orgId = this.props.match.params.orgId;
    this.props.app.api.orgsIdGet(orgId)
      .then(response => {
        // Remember data
        this.setState({ org: response.data.org });
        // A user who navigates away (e.g. via the footer) before this resolves must not have the
        // page they landed on next overwritten by this stale write.
        if (!this.unmounted) Title.set(Utils.displayName(response.data.org, orgId));
      }, error => {
        this.setState({ notFound: true });
        if (!this.unmounted) Title.setNotFound();
      });
  }

  // Where each tab goes. Read by the links themselves and by the arrow-key handler below, so the two
  // can never point at different places.
  tabPaths() {
    const orgId = this.props.match.params.orgId;
    return { blobs: `/${orgId}`, settings: `/${orgId}/settings` };
  }

  // The tabs are links and navigate on their own; arrow-key traversal belongs to react-bootstrap,
  // which reports the tab it reached here instead of activating its link.
  handleKeyboardTraverse = (key, event) => {
    if (!isNavKeyboardSelect(event)) return;
    const path = this.tabPaths()[key];
    if (path) this.props.history.push(path);
  };

  render() {
    if ( this.state.notFound ) {
      return (
        <>
          <Container className="blob-header-row header-message-row">
            <Alert variant="warning">Requested organization has not been found.</Alert>
          </Container>
        </>
      );
    }

    if ( !this.state.org ) {
      return (
        <>
          <Container className="blob-header-row header-message-row">
            <Alert variant="primary">Loading organization profile...</Alert>
          </Container>
        </>
      );
    }

    const orgId = this.props.match.params.orgId;
    const tabPaths = this.tabPaths();

    let section = "blobs";
    if ( 0 == this.props.match.path.indexOf("/" + orgId + "/settings") ) {
      section = "settings";
    }

    return (
      <>
        <Profile
          app={this.props.app}
          org={this.state.org}
        />
        <br/>

        <Container className="blob-header-row main-tabs">
          <Nav
            variant="tabs"
            as="nav"
            role="tablist"
            activeKey={section}
            onSelect={this.handleKeyboardTraverse}
          >
            <Nav.Link eventKey="blobs" role="tab" className="nav-item" as={Link} to={tabPaths.blobs}>
              <GoRepo/> Blobs
            </Nav.Link>
            {this.props.app.api.canAccessOrgSettings(this.state.org) &&
              <Nav.Link
                eventKey="settings"
                role="tab"
                className="nav-item"
                as={Link}
                to={tabPaths.settings}
              ><GoGear/> Settings</Nav.Link>
            }
          </Nav>
        </Container>

        <div className={"blobs" === section ? "" : "hidden"}>
          <Blobs
            app={this.props.app}
            orgId={orgId}
            org={this.state.org}
            blobs={this.state.blobs}
          />
        </div>

        {this.props.app.api.canAccessOrgSettings(this.state.org) &&
          <div className={"settings" === section ? "" : "hidden"}>
            <Settings
              history={this.props.history}
              app={this.props.app}
              match={this.props.match}
              org={this.state.org}
              orgId={orgId}
              profileInterface={this.profileInterface}
            />
          </div>
        }

        <br/>
      </>
    )
  }
}
